/*
 * TMB runtime error logger (#111)
 *
 * Lightweight front-end logger. Errors POST to /exec with action=logError;
 * server appends to an Errors tab on the Directory sheet. Helper exposed
 * as window.tmbLogError(type, msg, ctx) for manual use inside fetch
 * catches and other defensive paths.
 *
 * Foundational rules:
 *   - never throw back into the page
 *   - 60s client dedupe so a render loop can't spam the endpoint
 *   - silently drop if no endpoint is configured (e.g. early page boot)
 *   - own no-op POSTs cannot themselves trigger logError (no recursion)
 *
 * Endpoint discovery: looks for window.TMB_LOG_ENDPOINT (set by host
 * pages) OR falls back to scanning [data-endpoint] attributes from
 * known TMB section roots.
 */
(function () {
  'use strict';

  if (window.tmbLogError) return;  // already initialised

  function pickEndpoint_() {
    if (window.TMB_LOG_ENDPOINT) return window.TMB_LOG_ENDPOINT;
    // Scan known TMB roots in priority order.
    var roots = [
      '.tmb-merged[data-endpoint]',
      '.tmb-hub[data-endpoint]',
      '#coach-root[data-endpoint]',
      '[data-tmb-endpoint]',
    ];
    for (var i = 0; i < roots.length; i++) {
      var el = document.querySelector(roots[i]);
      if (el) {
        var ep = el.getAttribute('data-endpoint') || el.getAttribute('data-tmb-endpoint');
        if (ep) return ep;
      }
    }
    // Athlete-page config, exposed by training-plan-v2 section.
    if (window.TMB_PLAN_CONFIG && window.TMB_PLAN_CONFIG.endpoint) {
      return window.TMB_PLAN_CONFIG.endpoint;
    }
    return '';
  }

  function readEmail_() {
    try { return localStorage.getItem('tmb_hub_email') || ''; } catch (_e) { return ''; }
  }
  function readPlanToken_() {
    if (window.TMB_PLAN_CONFIG && window.TMB_PLAN_CONFIG.token) {
      return String(window.TMB_PLAN_CONFIG.token);
    }
    return '';
  }

  // 60s dedupe, same (type, message) pair won't fire twice within
  // the window. Prevents render-loop / RAF-loop spam.
  var DEDUPE_WINDOW_MS = 60000;
  var _seen = {};
  var _inFlight = false;
  function isDuplicate_(type, message) {
    var key = String(type || '') + '|' + String(message || '');
    var last = _seen[key];
    if (last && (Date.now() - last) < DEDUPE_WINDOW_MS) return true;
    _seen[key] = Date.now();
    return false;
  }

  window.tmbLogError = function tmbLogError(type, message, ctx) {
    try {
      if (_inFlight) return;  // own POST shouldn't recurse
      var endpoint = pickEndpoint_();
      if (!endpoint) return;  // no destination, drop quietly
      if (isDuplicate_(type, message)) return;
      ctx = ctx || {};
      _inFlight = true;
      var body = {
        action:    'logError',
        type:      String(type || 'unknown'),
        message:   String(message || ''),
        stack:     String(ctx.stack || ''),
        pageUrl:   String(window.location && window.location.href || ''),
        email:     String(ctx.email || readEmail_() || ''),
        planToken: String(ctx.planToken || readPlanToken_() || ''),
        userAgent: String(navigator.userAgent || ''),
        notes:     String(ctx.notes || ''),
      };
      // Fire and forget; never let a logging failure bubble up.
      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify(body),
        // keepalive lets the request survive page-close on unload
        // errors. Browsers cap keepalive bodies at 64KB which we're
        // well under (each field is per-server truncated too).
        keepalive: true,
      }).then(function () {}, function () {}).then(function () { _inFlight = false; },
                                                    function () { _inFlight = false; });
    } catch (_e) {
      _inFlight = false;
    }
  };

  // window.onerror, uncaught JS errors. Browser passes (message, src,
  // line, col, err). The Error object's .stack is the most useful field.
  window.addEventListener('error', function (ev) {
    try {
      var err = ev && ev.error;
      window.tmbLogError(
        'uncaught',
        (err && err.message) || ev.message || 'unknown error',
        {
          stack: (err && err.stack) || '',
          notes: (ev.filename || '') + ':' + (ev.lineno || '') + ':' + (ev.colno || ''),
        }
      );
    } catch (_e) {}
  });

  // Unhandled promise rejection.
  window.addEventListener('unhandledrejection', function (ev) {
    try {
      var reason = ev && ev.reason;
      var msg = '';
      var stack = '';
      if (reason instanceof Error) {
        msg = reason.message;
        stack = reason.stack || '';
      } else if (typeof reason === 'string') {
        msg = reason;
      } else {
        try { msg = JSON.stringify(reason); } catch (_e) { msg = String(reason); }
      }
      window.tmbLogError('unhandled_rejection', msg, { stack: stack });
    } catch (_e) {}
  });
})();
